export default __webpack_public_path__ + "static/media/uni1.f0caf2c3.png";